export default {
  title: 'Tréning modelu',
  subtitle: 'Vytvárajte nové modely strojového učenia na predpovedanie správania snímačov na základe iných dostupných snímačov',
  saveAction: 'Trénovať model',
  selectTargetHeadline: 'Cieľový signál',
  selectFeaturesHeadline: 'Príznakové signály',
  selectTrainingData: 'Tréningové dáta',
  configureModel: 'Konfigurácia modelu',
  modelDisplayName: 'Názov modelu',
};
